export const PARTS_MIN_QUANTITY = 1;
export const PARTS_MAX_QUANTITY = 99999;
export const PARTS_DIAGRAM_IMAGE =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240905-e34ca-3d319';
